import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '@sarasanalytics-com/design-system';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MfaService } from 'src/app/services/mfa/mfa.service';

@Component({
  selector: 'app-expire-mfa',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './expire-mfa.component.html',
  styleUrl: './expire-mfa.component.scss'
})
export class ExpireMfaComponent {
  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private mfaService: MfaService = inject(MfaService);

  backToProducts(){
    this.mfaService.cancleSetup();
  }

  logout(){
    this.mfaService.cancleSetup();
    this.authService.logOut();
  }
}
